/** One run (and one approval) per `<repo path> + <configuration name>`. */
export const runKey = (repoPath, name) => `${repoPath}\u0000${name}`;
